
import styled from 'styled-components'

export const Checkboxinput = styled.input`
    margin: 5px;
    margin-right: 3px;
    margin-left: 10px;
    display: inline-block;
    font-size: 15px;

  `
export const Typeheader = styled.h3`
  margin: 10px;
  font-size: 1.7em;
`

export const Selectwrapper = styled.div`
  margin: 20px 0px;
  /* font-size: 12px; */
`

export const Inputwrap = styled.div`
  display: inline-block;
  font-size: 18px;
`
